import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[mcListItem]'
})
export class ListItemDirective {
  constructor(public templateRef: TemplateRef<any>) { }
}
